<template>
  <el-select
    value-key="Key"
    v-model="data"
    @change="dataChange"
    :clearable="clearable"
    @clear="dataChange"
    :filterable="true"
    size="small"
    :disabled="disabled || readonly"
  >
    <el-option
      v-for="item in options"
      :key="item.Key"
      :label="item.Name"
      :value="item"
    >
      <div class="proItem">
        <div class="name">
          {{ item.Name }}
        </div>
      </div>
    </el-option>
  </el-select>
</template>
<script>
import { getAll } from "@/api/setting/tenant";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
    clearable: {
      default: true,
    },
    disabled: {
      default: false,
    },
    readonly: {
      default: false,
    },
    onlyShop: {
      default: true,
    },
  },
  data() {
    return {
      options: [],
      data: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        this.data = v;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getData() {
      let param = {
        onlyShop: this.onlyShop,
      };
      getAll(param).then((res) => {
        if (res) {
          this.options = res.Items;
        }
      });
    },
    dataChange(v) {
      this.$emit("change", v);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang='scss' scoped>
.proItem {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .name {
  }

  .companys {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .company {
      font-size: 10px;
      line-height: 16px;
      color: silver;
      margin-bottom: 10px;
      font-weight: normal;
    }
  }
}
</style>